import React from 'react';
import { render } from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import './css/style.css';

import Header from './components/Header';
import Footer from './components/Footer';
import TheContent from './components/TheContent';

const Root = () => {
	return (
		<Router>
			<div className="content">
				<Header location={location} className="header"/>
				<TheContent location={location}/>
				<Footer location={location}/>
			</div>
		</Router>
	)
}

render(<Root/>, document.querySelector('#cgh'));


/** WEBPACK FOOTER **
 ** ./src/index.js
 **/